<style lang="scss" scoped>
</style>
<template>
    <div class="fullpage bg_fff">
        <div class="Section0" style="layout-grid:15.6000pt;">
            <zc-table></zc-table>
            <p class=MsoNormal><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;"><font face="宋体">备注：</font></span></b><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><font face="宋体">本单子一式两份，分别由转出医院及救护车保存</font></span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"></span></p>
        </div>
    </div>
</template>
<script>
  import ZcTable from "../components/zc-table";

  export default {
    name: 'form-zc',
    components: {ZcTable}
  }
</script>
